import type { SWRResponse } from "swr";
import useSWR from "swr";
import type { Nullable } from "../../../@types/generic";
import { useCountry } from "../../../components/ApplicationState/hooks";
import { numberToString } from "../../../helpers/formatters/values";
import { QUERY_NAME_LOCATION_SUMMARY } from "../../cacheKeys";
import { getLocationSummary } from "../api/locationSummary";
import type { LocationSummary } from "../types/locationSummary";

export const useLocationSummary = (
    code: Nullable<string | undefined>,
    limitForecastSummaryItems?: number
): SWRResponse<Nullable<LocationSummary>> => {
    const country = useCountry();
    const { data, isLoading, ...rest } = useSWR<Nullable<LocationSummary>>(
        numberToString(code) !== ""
            ? [
                  QUERY_NAME_LOCATION_SUMMARY,
                  code,
                  limitForecastSummaryItems,
                  country,
              ]
            : null,
        () =>
            getLocationSummary(
                code as string,
                country,
                limitForecastSummaryItems
            )
    );

    return {
        data,
        isLoading: isLoading || data === undefined,
        ...rest,
    };
};
